import React from 'react';
import LeftToolbar from './Comps/LeftToolbar';

function BuxLayout(props) {
    return (
        <div>
            <LeftToolbar /> 
            <h1>BUXGALTERIYA</h1>

        </div>
    );
}

export default BuxLayout;